import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface FileUploadResponse {
  url: string;
  fileName: string;
  sizeBytes: number;
}

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private apiUrl = `${environment.apiUrl}/files`;

  constructor(private http: HttpClient) {}

  /**
   * Upload a file to the server
   * Returns the URL where the file is stored
   */
  uploadFile(file: File, type: 'document' | 'image' = 'document'): Observable<FileUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);

    return this.http.post<FileUploadResponse>(`${this.apiUrl}/upload`, formData);
  }

  /**
   * Upload multiple files
   */
  uploadMultipleFiles(files: File[], type: 'document' | 'image' = 'document'): Observable<FileUploadResponse[]> {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });
    formData.append('type', type);

    return this.http.post<FileUploadResponse[]>(`${this.apiUrl}/upload-multiple`, formData);
  }

  /**
   * Delete a file from the server
   */
  deleteFile(url: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}`, {
      params: { url }
    });
  }
}
